import {
    type BoundParameterValue,
    isBoolean,
    isDiscrete,
    isRange,
    isText,
    isMultiValue,
    isLocation,
    isConstant,
    isTiered,
    isFile,
    isRemarks,
} from "../api";
import { ResolvedBooleanValue } from "./ResolvedBooleanValue";
import { ResolvedConstantValue } from "./ResolvedConstantValue";
import { ResolvedDiscreteValue } from "./ResolvedDiscreteValue";
import { ResolvedFileValue } from "./ResolvedFileValue";
import { ResolvedLocationValue } from "./ResolvedLocationValue";
import { ResolvedMultiValueValue } from "./ResolvedMultiValueValue";
import { type ResolvedParameterValue } from "./ResolvedParameterValue";
import { ResolvedRangeValue } from "./ResolvedRangeValue";
import { ResolvedRemarksValue } from "./ResolvedRemarksValue";
import { ResolvedTextValue } from "./ResolvedTextValue";
import { ResolvedTieredValue } from "./ResolvedTieredValue";
/**
 * Resolves a parameter value to a specific type.
 *
 * @param value The bound parameter value to resolve.
 * @returns The resolved parameter value.
 */
export const resolveParameterValue = (value: BoundParameterValue): ResolvedParameterValue | never => {
    if (isDiscrete(value)) {
        return ResolvedDiscreteValue.create(value);
    }
    if (isRange(value)) {
        return ResolvedRangeValue.create(value);
    }
    if (isBoolean(value)) {
        return ResolvedBooleanValue.create(value);
    }
    if (isText(value)) {
        return ResolvedTextValue.create(value);
    }
    if (isMultiValue(value)) {
        return ResolvedMultiValueValue.create(value);
    }
    if (isLocation(value)) {
        return ResolvedLocationValue.create(value);
    }
    if (isConstant(value)) {
        return ResolvedConstantValue.create(value);
    }
    if (isTiered(value)) {
        return ResolvedTieredValue.create(value);
    }
    if (isFile(value)) {
        return ResolvedFileValue.create(value);
    }
    if (isRemarks(value)) {
        return ResolvedRemarksValue.create(value);
    }
    throw new Error(
        `ParameterValue: Cannot resolve parameter value with unknown kind '${String(value?.kind ?? "null")}'.`
    );
};
